import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { AnalyticsService } from '../analytics/analytics.service';
import { AngularEnvironment } from '../env';
import { UtilityService } from '../util';
import { ExternalAuthError, ExternalAuthState } from './external-auth-state';


/**
 * Return a function suitable for Firebase's onAuthStateChanged()
 */
export function getAuthStateChangedHandler(
	auth: firebase.auth.Auth,
	analytics: AnalyticsService,
	util: UtilityService,
	router: Router,
	setState: (state: ExternalAuthState) => void,
	env: AngularEnvironment,
) {


	return async (user: firebase.User | null) => {

		util.log.info('onAuthStateChanged', { extra: user, extraLogging: 'ExtraToConsole' })

		//
		// Clear out any data stored on the router
		//
		router.resetConfig(router.config);

		if (!user) {

			setState({ status: 'signed-out' });

		}
		else {

			const redirect = await firebase.auth().getRedirectResult();
			const fromPersistence = redirect?.user == undefined;

			const email = user.email;

			if (!email) {
				await auth.signOut();
				setState({ status: 'error', error: ExternalAuthError.EmailNotVerified });
				throw new Error(`No Email Address`);	// TODO: communicate through ErrorService
			}
			else if (!user.emailVerified) {
				await user.sendEmailVerification();
				setState({ status: 'email-password-verification-email-sent', user });
			}
			else {

				analytics.logLogin({ email, provider: user.providerId });

				setState({
					status: 'signed-in',
					user,
					loginType: fromPersistence ? 'from-persistence' : 'new',
				});
			}
		}
	}

}